import { DataType } from "@/jenesys-types/data/enums";

import { ReconStatementCrudRoute } from "@/components/routes/reconciliation/ReconStatementCrudRoute";
import { createCrudRoute } from "@/routes/crud";
import { ReconStatementList } from "@/routes/lazyFeatures";

export default () =>
  createCrudRoute({
    path: "reconciliation/:reconciliationId/statement",
    dataType: DataType.BankStatement,
    element: <ReconStatementCrudRoute />,
    list: <ReconStatementList />
  });
